module.exports = "input {\n  width: 300px; }\n"